// extracted by mini-css-extract-plugin
export default {"intro":"Home_intro__u-Gk+","introHead":"Home_introHead__MZsO7"};